import Button from '@src/component/ButtonV2'
import Tooltip from '@ui/Tooltip'
import { XIcon } from '@ui/icons/tint/16/general'
import { VStack } from '@ui/layout/Stack'

import Content from './CallQualityFeedback/CallQualityFeedbackContent'
import Header from './CallQualityFeedback/CallQualityFeedbackHeader'
import * as styles from './CallQualityFeedback.css'

type CallQualityFeedbackProps = {
  children?: React.ReactNode
  onClose?: () => void
}

function CallQualityFeedback({ children, onClose }: CallQualityFeedbackProps) {
  return (
    <VStack alignItems="center" gap={4} className={styles.root}>
      {onClose && (
        <Tooltip title="Close" themeKey="dark">
          {/* eslint-disable-next-line custom-rules/no-deprecated-buttons, @typescript-eslint/no-deprecated -- FIXME: https://linear.app/openphone/issue/UXP-4347/migrate-deprecated-buttons-to-ds-button */}
          <Button
            variant="text"
            height={24}
            className={styles.closeButton}
            color="textSecondary"
            onClick={onClose}
          >
            <XIcon />
          </Button>
        </Tooltip>
      )}
      {children}
    </VStack>
  )
}

CallQualityFeedback.Header = Header
CallQualityFeedback.Content = Content

export default CallQualityFeedback
